module.exports = __webpack_public_path__ + "img/左边图.58bc2afe.png";